import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/logo/ic_launcher.png';
const _withScopeId = n => (_pushScopeId("data-v-474da021"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ml50 pt20 mr50 pb50"
};
const _hoisted_2 = {
  class: "flex_FSBC"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "flex"
};
const _hoisted_6 = {
  class: "form_box mt10"
};
const _hoisted_7 = {
  class: "mr90"
};
const _hoisted_8 = {
  class: "mr90"
};
const _hoisted_9 = {
  key: 0,
  class: "_table mt15"
};
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"flex_FSBC _table_items sticky\" data-v-474da021><p class=\"_table_label\" data-v-474da021>装货地</p><p class=\"_table_label\" data-v-474da021>卸货地</p><p class=\"_table_label\" data-v-474da021>货物</p><p class=\"_table_label\" data-v-474da021>剩余数量</p><p class=\"_table_label\" data-v-474da021>单位</p><p class=\"_table_label\" data-v-474da021>价格</p><p class=\"_table_label\" data-v-474da021>需求车型</p><p class=\"_table_label\" data-v-474da021>需求车长</p><p class=\"_table_label\" data-v-474da021>排放标准</p><p class=\"_table_label\" style=\"flex:2;\" data-v-474da021>操作</p></div>", 1);
const _hoisted_11 = {
  class: "flex_FSBC _table_items_desc pb15"
};
const _hoisted_12 = {
  class: "mr15"
};
const _hoisted_13 = {
  class: "flex_FSBC mt15"
};
const _hoisted_14 = {
  class: "_table_label"
};
const _hoisted_15 = {
  class: "_table_label"
};
const _hoisted_16 = {
  class: "_table_label"
};
const _hoisted_17 = {
  class: "_table_label"
};
const _hoisted_18 = {
  class: "_table_label"
};
const _hoisted_19 = {
  class: "_table_label"
};
const _hoisted_20 = {
  class: "_table_label"
};
const _hoisted_21 = {
  class: "_table_label"
};
const _hoisted_22 = {
  class: "_table_label"
};
const _hoisted_23 = {
  class: "flex_FCAC _table_label",
  style: {
    "flex": "2"
  }
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 0,
  class: "pointer mr15 text_red"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  key: 1,
  class: "mt15 history flex flexW"
};
const _hoisted_30 = {
  class: "flex_FSBS"
};
const _hoisted_31 = {
  class: "flex_size_1"
};
const _hoisted_32 = {
  class: "history_item_title"
};
const _hoisted_33 = {
  class: "history_item_text mt5"
};
const _hoisted_34 = {
  class: "history_item_desc mt5"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "success_order flex_FCAC flex_column"
}, [/*#__PURE__*/_createElementVNode("p", null, "完成"), /*#__PURE__*/_createElementVNode("p", null, "订单")], -1));
const _hoisted_36 = {
  class: "flex mt45"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  class: "flex_FCAC"
};
const _hoisted_40 = {
  key: 0,
  class: "share_pic",
  id: "shareImage"
};
const _hoisted_41 = {
  class: "share_pic p20",
  ref: "picContainer"
};
const _hoisted_42 = {
  class: "flex_FSBS mb20"
};
const _hoisted_43 = {
  class: "flex_size_1 flex_FSBS"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot"
}, "装", -1));
const _hoisted_45 = {
  class: "flex_size_1 flex_column flex_FS"
};
const _hoisted_46 = {
  class: "mb5"
};
const _hoisted_47 = {
  class: "textL text_grey"
};
const _hoisted_48 = {
  class: "flex_size_1 flex_FSBS ml20"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot bg_red"
}, "卸", -1));
const _hoisted_50 = {
  class: "flex_size_1 flex_column flex_FS"
};
const _hoisted_51 = {
  class: "mb5"
};
const _hoisted_52 = {
  class: "textL text_grey"
};
const _hoisted_53 = {
  class: "textC"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text_grey pr20"
}, "预估运输里程", -1));
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "bold mt20 title"
}, "车货信息", -1));
const _hoisted_56 = {
  class: "flex_FSBS mt20"
};
const _hoisted_57 = {
  class: "flex_size_1"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "pr10"
}, "货物", -1));
const _hoisted_59 = {
  class: "flex_size_1"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "pr10"
}, "重量", -1));
const _hoisted_61 = {
  class: "flex_size_1"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "pr10"
}, "包装", -1));
const _hoisted_63 = {
  class: "flex_FSBS mt20"
};
const _hoisted_64 = {
  class: "flex_size_1"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "pr10"
}, "车型", -1));
const _hoisted_66 = {
  class: "flex_size_1"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "pr10"
}, "车长", -1));
const _hoisted_68 = {
  class: "flex_size_1"
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "pr10"
}, "运输", -1));
const _hoisted_70 = {
  class: "flex_FSBS mt20"
};
const _hoisted_71 = {
  class: "flex_size_1"
};
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "pr10"
}, "运单费用", -1));
const _hoisted_73 = {
  class: "share_pic_info mt20 flex_FSBC"
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_FAC"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "share_pic_info_logo",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "ml10"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "bold share_pic_info_title text_black mb10"
}, " 九运易合 "), /*#__PURE__*/_createElementVNode("p", {
  class: "share_pic_info_desc text_black"
}, " 货源多多，车辆多多，智能匹配 ")])], -1));
const _hoisted_75 = {
  ref: "qrCanvas"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Download = _resolveComponent("Download");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.comps, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['tab pointer', index == $setup.data.tabsIndex && 'active']),
      onClick: () => $setup.serarch(index),
      key: index
    }, _toDisplayString(item.label), 11, _hoisted_4);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: _cache[0] || (_cache[0] = () => $setup.isPassAuth('/layout/ordinary', _ctx.$router))
  }, {
    default: _withCtx(() => [_createTextVNode("发布货源")]),
    _: 1
  }), _createVNode(_component_el_upload, {
    "auto-upload": false,
    action: "#",
    "show-file-list": false,
    accept: ".xlsx,.xls",
    "on-change": data => $setup.importVehicleType(data)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      class: "ml25"
    }, {
      default: _withCtx(() => [_createTextVNode(" 导入货源 ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["on-change"]), _createVNode(_component_el_button, {
    type: "primary",
    class: "ml25",
    onClick: _cache[1] || (_cache[1] = () => $setup.downloadDemandTemplate())
  }, {
    default: _withCtx(() => [_createTextVNode(" 模板下载 ")]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, {
    class: "flex flex_FS"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form_item, {
      label: "货源单号"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.data.demandNo,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.data.demandNo = $event),
        placeholder: "请输入货源单号"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "卸货地"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.data.toAddress,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.data.toAddress = $event),
        placeholder: "请输入卸货地"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form_item, {
      label: "装货地"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.data.fromAddress,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.data.fromAddress = $event),
        placeholder: "请输入装货地"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_date_picker, {
        clearable: false,
        modelValue: $setup.data.datePickerVal,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.data.datePickerVal = $event),
        type: "daterange",
        "range-separator": "至",
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD",
        onChange: $setup.pickDateHandle
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    })]), _createVNode(_component_el_form_item, {
      label: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[6] || (_cache[6] = () => $setup.serarch($setup.data.tabsIndex))
      }, {
        default: _withCtx(() => [_createTextVNode("查询")]),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: $setup.reset
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  })]), !$setup.data.tabsIndex ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.list, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.demandNo,
      class: "_table_items mt15"
    }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, "创建时间：" + _toDisplayString($setup.moment(item.createTime).format("YYYY-MM-DD")), 1), _createElementVNode("span", null, "货源单号：" + _toDisplayString(item.demandNo), 1)]), _createElementVNode("div", null, "详细地址：" + _toDisplayString(item.fromAddress) + " → " + _toDisplayString(item.toAddress), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString(item.fromCity), 1), _createElementVNode("p", _hoisted_15, _toDisplayString(item.toCity), 1), _createElementVNode("p", _hoisted_16, _toDisplayString(item.goodsName), 1), _createElementVNode("p", _hoisted_17, _toDisplayString((item.surplusWeight || 0) / 100), 1), _createElementVNode("p", _hoisted_18, _toDisplayString($setup.freightUnitTypeMap[item.unitType == 2 ? 0 : item.unitType].text), 1), _createElementVNode("p", _hoisted_19, _toDisplayString(item.amount / 100) + "元/" + _toDisplayString($setup.freightUnitTypeMap[item.unitType].text), 1), _createElementVNode("p", _hoisted_20, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.carModelList.join('/'),
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.carModelList.join("/")), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_21, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.carLengthList.join('/'),
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.carLengthList.join("/")), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_22, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.carDisplacementList.join('/'),
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.carDisplacementList.join("/")), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("p", {
      class: "pointer mr15 text_blue",
      onClick: () => $setup.toViewDemandDetail(item.demandId)
    }, " 查看 ", 8, _hoisted_24), _createVNode(_component_el_popconfirm, {
      title: "您确定下架该货源信息？",
      "confirm-button-text": "确定",
      "cancel-button-text": "取消",
      onConfirm: () => $setup.handleDeleteDemand(item.demandId)
    }, {
      reference: _withCtx(() => [$setup.data.tabsIndex == '0' ? (_openBlock(), _createElementBlock("p", _hoisted_25, " 下架 ")) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["onConfirm"]), $setup.data.tabsIndex == '0' ? (_openBlock(), _createElementBlock("p", {
      key: 0,
      class: "pointer mr15 text_blue",
      onClick: () => $setup.edit(item.demandId)
    }, " 编辑 ", 8, _hoisted_26)) : _createCommentVNode("", true), $setup.data.tabsIndex == '0' ? (_openBlock(), _createElementBlock("p", {
      key: 1,
      class: "pointer mr15 text_blue",
      onClick: () => $setup.addDemandPrice(item.demandId, item.amount)
    }, " 改价 ", 8, _hoisted_27)) : _createCommentVNode("", true), $setup.data.tabsIndex == '0' ? (_openBlock(), _createElementBlock("p", {
      key: 2,
      class: "pointer text_blue",
      onClick: () => $setup.sharePic(item)
    }, " 分享 ", 8, _hoisted_28)) : _createCommentVNode("", true)])])]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "history_item",
      key: item.demandNo
    }, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("p", _hoisted_32, _toDisplayString(item.fromCity) + " → " + _toDisplayString(item.toCity), 1), _createElementVNode("p", _hoisted_33, _toDisplayString(item.carModelList.join("/")) + " " + _toDisplayString(item.carLengthList.join("/")) + " " + _toDisplayString(item.carDisplacementList.join("/")) + " " + _toDisplayString(item.goodsName), 1), _createElementVNode("p", _hoisted_34, _toDisplayString($setup.moment(item.createTime).format("YYYY-MM-DD")), 1)]), _hoisted_35]), _createElementVNode("div", _hoisted_36, [_createElementVNode("p", {
      class: "flex_size_1 view_detail_btn pointer mr5",
      onClick: () => $setup.toViewDemandDetail(item.demandId)
    }, " 查看详情 ", 8, _hoisted_37), _createElementVNode("p", {
      class: "flex_size_1 again_btn pointer ml5",
      onClick: () => $setup.edit(item.demandId, 1)
    }, " 再发一单 ", 8, _hoisted_38)])]);
  }), 128))])), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_config_provider, {
    locale: $setup.zhCn
  }, {
    default: _withCtx(() => [_createVNode(_component_el_pagination, {
      "page-size": $setup.data.size,
      class: "mt40",
      background: "",
      layout: "pager,total",
      total: $setup.data.total,
      onCurrentChange: $setup.currentChange
    }, null, 8, ["page-size", "total", "onCurrentChange"])]),
    _: 1
  }, 8, ["locale"])])]), _createVNode(_component_el_dialog, {
    title: "分享图片预览",
    style: {
      "width": "40%"
    },
    modelValue: $setup.dialog.visible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $setup.dialog.visible = $event),
    "show-close": false,
    "close-on-press-escape": false,
    center: ""
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      onClick: _cache[7] || (_cache[7] = () => $setup.copyPic())
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "pr5"
      }, {
        default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
        _: 1
      }), _createTextVNode("复制图片")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[8] || (_cache[8] = () => $setup.downloadPic())
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "pr5"
      }, {
        default: _withCtx(() => [_createVNode(_component_Download)]),
        _: 1
      }), _createTextVNode("下载图片")]),
      _: 1
    })]),
    default: _withCtx(() => [$setup.dialog.bufferRecord?.demandId ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("div", _hoisted_45, [_createElementVNode("p", _hoisted_46, _toDisplayString($setup.dialog.bufferRecord?.loading.province) + _toDisplayString($setup.dialog.bufferRecord?.loading.city) + _toDisplayString($setup.dialog.bufferRecord?.loading.district), 1), _createElementVNode("p", _hoisted_47, _toDisplayString($setup.dialog.bufferRecord?.loading.address), 1)])]), _createElementVNode("div", _hoisted_48, [_hoisted_49, _createElementVNode("div", _hoisted_50, [_createElementVNode("p", _hoisted_51, _toDisplayString($setup.dialog.bufferRecord?.unloading.province) + _toDisplayString($setup.dialog.bufferRecord?.unloading.city) + _toDisplayString($setup.dialog.bufferRecord?.unloading.district), 1), _createElementVNode("p", _hoisted_52, _toDisplayString($setup.dialog.bufferRecord?.unloading.address), 1)])])]), _createElementVNode("p", _hoisted_53, [_hoisted_54, _createElementVNode("b", null, _toDisplayString($setup.dialog.bufferRecord?.distance) + "KM", 1)]), _hoisted_55, _createElementVNode("div", _hoisted_56, [_createElementVNode("p", _hoisted_57, [_hoisted_58, _createTextVNode(" " + _toDisplayString($setup.dialog.bufferRecord?.goodsName), 1)]), _createElementVNode("p", _hoisted_59, [_hoisted_60, _createTextVNode(" " + _toDisplayString($setup.dialog.bufferRecord?.tonnage / 100), 1)]), _createElementVNode("p", _hoisted_61, [_hoisted_62, _createTextVNode(" " + _toDisplayString($setup.dialog.bufferRecord?.packageName), 1)])]), _createElementVNode("div", _hoisted_63, [_createElementVNode("p", _hoisted_64, [_hoisted_65, _createTextVNode(" " + _toDisplayString($setup.dialog.bufferRecord?.carModelList.join("/")), 1)]), _createElementVNode("p", _hoisted_66, [_hoisted_67, _createTextVNode(" " + _toDisplayString($setup.dialog.bufferRecord?.carLengthList.join("/")), 1)]), _createElementVNode("p", _hoisted_68, [_hoisted_69, _createTextVNode(" " + _toDisplayString($setup.dialog.bufferRecord?.carDisplacementList.join("/")), 1)])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("p", _hoisted_71, [_hoisted_72, _createTextVNode(" " + _toDisplayString($setup.dialog.bufferRecord?.amount / 100) + "元/" + _toDisplayString($setup.freightUnitTypeMap[$setup.dialog.bufferRecord?.unitType].text), 1)])]), _createElementVNode("div", _hoisted_73, [_hoisted_74, _createElementVNode("canvas", _hoisted_75, null, 512)])], 512)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue"])], 64);
}